import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DROPDOWN_ALL_TEXT, DROPDOWN_ALL_VALUE, DROPDOWN_SELECT_ALL_TEXT, NOT_SELECTED_TEXT, NOT_SELECTED_VALUE } from '@lib/i18n/utils';
import { DropdownOption } from '@platform-workspace/design-system';

import { TranslationService } from '../translation/translation.service';

@Injectable({
  providedIn: 'root',
})
export class DropdownAllOptionService {
  private readonly translationService = inject(TranslationService);
  private readonly destroyRef = inject(DestroyRef);

  private readonly dropdownAllOption = signal<DropdownOption>({
    text: this.translationService.translate(DROPDOWN_ALL_TEXT),
    value: DROPDOWN_ALL_VALUE,
  });

  private readonly dropdownSelectAllOption = signal<DropdownOption>({
    text: this.translationService.translate(DROPDOWN_SELECT_ALL_TEXT),
    value: DROPDOWN_ALL_VALUE,
  });

  private readonly notSelectedOption = signal<DropdownOption>({
    text: this.translationService.translate(NOT_SELECTED_TEXT),
    value: NOT_SELECTED_VALUE,
  });

  readonly allOption = this.dropdownAllOption.asReadonly();
  readonly selectAllOption = this.dropdownSelectAllOption.asReadonly();
  readonly notSelected = this.notSelectedOption.asReadonly();

  constructor() {
    this.translationService
      .onLangChange()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.dropdownAllOption.set({
          text: this.translationService.translate(DROPDOWN_ALL_TEXT),
          value: DROPDOWN_ALL_VALUE,
        });
        this.dropdownSelectAllOption.set({
          text: this.translationService.translate(DROPDOWN_SELECT_ALL_TEXT),
          value: DROPDOWN_ALL_VALUE,
        });
        this.notSelectedOption.set({
          text: this.translationService.translate(NOT_SELECTED_TEXT),
          value: NOT_SELECTED_VALUE,
        });
      });
  }
}
